import { Decimal } from "decimal.js";

// formatAmount returns the amount as a currency.
export function formatAmount(amount: Decimal): string {
  return `$${amount.toFixed(2)}`;
}
